/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type tradeRewardsEndOfYearMessagingHelpers_rewards = {
    readonly pointsToMaintainStatus: number | null;
    readonly pointsNeededToLevelUp: string | null;
    readonly currentProgram: {
        readonly programInfo: {
            readonly code: string | null;
        } | null;
    } | null;
    readonly " $refType": "tradeRewardsEndOfYearMessagingHelpers_rewards";
};
export type tradeRewardsEndOfYearMessagingHelpers_rewards$data = tradeRewardsEndOfYearMessagingHelpers_rewards;
export type tradeRewardsEndOfYearMessagingHelpers_rewards$key = {
    readonly " $data"?: tradeRewardsEndOfYearMessagingHelpers_rewards$data;
    readonly " $fragmentRefs": FragmentRefs<"tradeRewardsEndOfYearMessagingHelpers_rewards">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "tradeRewardsEndOfYearMessagingHelpers_rewards"
};
(node as any).hash = '2de1a0f30b0f87e6cae7b867da41d73d';
export default node;
